import * as Apollo from '@apollo/client'
import {gql} from '@apollo/client'
import {UpdateCartItemsMutation, UpdateCartItemsMutationVariables} from '../../generated/graphql'
import CartEnumSmall from '../../../../enums/CartEnum/CartEnumSmall'

const defaultOptions = {} as const

export function useUpdateCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useMutation<UpdateCartItemsMutation, UpdateCartItemsMutationVariables>(UpdateCartItemsDocument, options)
}

export const UpdateCartItemsDocument = gql`
    mutation UpdateCartItems($cart_id: String!, $cart_items: [CartItemUpdateInput]!) {
        updateCartItems(input: {cart_id: $cart_id, cart_items: $cart_items}) {
            cart ${CartEnumSmall.getMutationCart()}
        }
    }
`